import ChangeWorkspaceDropdown from '@anm/components/workspace/ChangeWorkspaceDropdown';
import { useCallback, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { appMetaActions, appMetaSelectors } from '../../../store/modules/appMeta';
import { teamSelectors } from '../../../store/modules/team';
import { userSelectors } from '../../../store/modules/user';

export type MyProjectWorkspaceDropdownProps = {};

const ChangeWorkspaceDropdownWrapper = styled(ChangeWorkspaceDropdown)`
  margin-top: 10px;
`;

const MyProjectWorkspaceDropdown: FC<MyProjectWorkspaceDropdownProps> = () => {
  const dispatch = useDispatch();
  const currentWorkspace = useSelector(appMetaSelectors.selectWorkspace);
  const profile = useSelector(userSelectors.selectUserProfile);
  const teamAvatar = useSelector(teamSelectors.selectTeamAvatar);
  const teamName = useSelector(teamSelectors.selectTeamDisplayName);

  const handleWorkspaceChange = useCallback(
    newWorkspace => {
      newWorkspace !== currentWorkspace && dispatch(appMetaActions.update({ workspace: newWorkspace }));
    },
    [currentWorkspace]
  );

  return (
    <ChangeWorkspaceDropdownWrapper
      workspacesInfoList={[
        {
          workspace: 'team',
          title: teamName,
          avatar: teamAvatar
        },
        {
          workspace: 'user',
          title: profile?.displayName,
          avatar: profile?.avatar
        }
      ]}
      currentWorkspace={currentWorkspace}
      onWorkspaceChange={handleWorkspaceChange}
    />
  );
};

export default MyProjectWorkspaceDropdown;
